import React from 'react';
import { TextField } from '../../../atom/TextField';
import { TextArea } from '../../../atom/TextArea';
import { SelectField } from '../../../atom/SelectField';
import removeIcon from '../../../../assets/images/icons/removeFile.svg';

const TaskFields = ({
  selectedRow,
  currentCategories,
  formatDate,
  stripHtmlAndFormat,
  getCategoryValue,
  transformCategoryOptions,
  handleRemoveImage,
  handleAddImage,
  filesToUpload = {},
  filesToDelete = {},
  API_URL,
  products = [],
  getProductValue,
  transformProductOptions,
  partners = [],
  getPartnerValue,
  transformPartnerOptions
}) => {
  return (
    <>
      <TextField name="customer_first_name" label="Kundens fornavn" value={selectedRow.customer_first_name} type="text" permission="edit" clName="half-col"/>
      <TextField name="customer_last_name" label="Kundens efternavn" value={selectedRow.customer_last_name} type="text" permission="edit" clName="half-col"/>
      <TextArea name="customer_address" label="Kundens fulde adresse" value={stripHtmlAndFormat(selectedRow.customer_address)} permission="edit" clName="full-col" rows={4}/>
      {currentCategories.housing_type && (
        <SelectField 
          name="housing_type"
          label="Boligtype" 
          value={getCategoryValue('housing_type', currentCategories.housing_type)} 
          permission="edit" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.housing_type, 'Boligtype')}
        />
      )}
      <TextField name="customer_email" label="Kundens e-mail" value={selectedRow.customer_email} type="email" permission="edit" clName="half-col"/>
      <TextField name="customer_phone_number" label="Kundens telefonnummer" value={selectedRow.customer_phone_number} type="phone" permission="edit" clName="half-col"/>
      {currentCategories.status && (
        <SelectField 
          name="status"
          label="Status" 
          value={getCategoryValue('status', currentCategories.status)} 
          permission="edit" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.status, null, false)}
        />
      )}
      {currentCategories.customer_has_paid && (
        <SelectField 
          name="customer_has_paid"
          label="Kunde har betalt" 
          value={getCategoryValue('customer_has_paid', currentCategories.customer_has_paid)} 
          permission="edit" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.customer_has_paid)}
        />
      )}
      {currentCategories.subcontractor_has_paid && (
        <SelectField 
          name="subcontractor_has_paid"
          label="UE er betalt" 
          value={getCategoryValue('subcontractor_has_paid', currentCategories.subcontractor_has_paid)} 
          permission="edit" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.subcontractor_has_paid)}
        />
      )}
      {currentCategories.status && (
        <SelectField 
          name="type"
          label="Type" 
          value={getCategoryValue('type', currentCategories.type)} 
          permission="edit" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.type, null, false)}
        />
      )}
      {currentCategories.status && (
        <SelectField 
          name="product_type"
          label="Produkttype" 
          value={getCategoryValue('product_type', currentCategories.product_type)} 
          permission="edit" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.product_type)}
        />
      )}
      <TextArea name="estimated_material_usage" label="Estimeret materiale forbrug:" value={stripHtmlAndFormat(selectedRow.estimated_material_usage)} permission="edit" clName="full-col" rows={4}/>
      
      <TextField name="start_date" label="Udførelsesdato" value={formatDate(selectedRow.start_date)} type="date" permission="edit" clName="half-col"/>
      <TextField name="end_date" label="Deadline Date" value={formatDate(selectedRow.end_date || selectedRow.deadline_date)} type="date" permission="edit" clName="half-col"/>
      <TextField name="next_sms_date_for_partners" label="Next SMS Date for partners" value={formatDate(selectedRow.next_sms_date_for_partners)} type="date" permission="edit" clName="half-col"/>
      <TextField name="sms_time_for_customer" label="Tidspunkt (SMS kunde)" value={selectedRow.sms_time_for_customer} type="text" permission="edit" clName="half-col"/>
      <TextField name="final_deadline_date" label="Deadline date: (Must be finished this day)" value={formatDate(selectedRow.final_deadline_date)} type="date" permission="edit" clName="half-col"/>
      <TextField name="paid_amount_to_painter" label="Paid amount for this task (Til maleren)" value={selectedRow.paid_amount_to_painter} type="number" permission="edit" clName="half-col"/>
      <TextArea name="extra_services" label="Ekstra ydelser" value={stripHtmlAndFormat(selectedRow.extra_services)} permission="edit" clName="full-col" rows={4}/>
      <TextArea name="internal_notes" label="Interne noter" value={stripHtmlAndFormat(selectedRow.internal_notes)} permission="edit" clName="full-col" rows={4}/>
      <TextArea name="internal_notes_to_admin" label="Interne Admin Noter" value={stripHtmlAndFormat(selectedRow.internal_notes_to_admin)} permission="edit" clName="full-col" rows={4}/>
      <TextArea name="invoice_description" label="Opgavebeskrivelse (På faktura)" value={stripHtmlAndFormat(selectedRow.invoice_description)} permission="edit" clName="full-col" rows={4}/>
      <SelectField 
        name="add_product"
        label="Tilføj produkt (Vælg ét produkt ad gangen)." 
        value={getProductValue ? getProductValue() : ''} 
        permission="edit" 
        clName="half-col"
        options={transformProductOptions ? transformProductOptions() : [{ value: '', label: 'Vælg produkt' }]}
      />
      <TextField name="price" label="Pris for opgaven inkl. moms." value={selectedRow.price} type="number" permission="edit" clName="half-col"/>
      <TextArea name="estimated_task_time" label="Estimeret tid for opgaven" value={stripHtmlAndFormat(selectedRow.estimated_task_time)} permission="edit" clName="full-col" rows={4}/>
      <TextArea name="free_text_for_additional_services" label="Fritekst til ekstraydelser" value={stripHtmlAndFormat(selectedRow.free_text_for_additional_services)} permission="edit" clName="full-col" rows={4}/>
      <TextArea name="not_included_in_offer" label="Ikke inkluderet i tilbuddet (tekst til kunde PDF)" value={stripHtmlAndFormat(selectedRow.not_included_price)} permission="edit" clName="full-col" rows={4}/>
      <TextArea name="free_of_charge" label="Uden beregning (Tekst til kunde PDF)" value={stripHtmlAndFormat(selectedRow.without_calculation)} permission="edit" clName="full-col" rows={4}/>
      <TextField name="hours_used" label="Timer brugt" value={selectedRow.hours_used} type="number" permission="edit" clName="half-col"/>
      <TextField name="materials_incl_vat" label="Materialer inkl. moms" value={selectedRow.materials_incl_vat} type="number" permission="edit" clName="half-col"/>
      <TextArea name="further_description_for_painting_is_displayed_on_pdf" label="Yderligere beskrivelse til Maler (Vises på maler PDF)" value={stripHtmlAndFormat(selectedRow.further_description_for_painting_is_displayed_on_pdf)} permission="edit" clName="full-col" rows={4}/>
      {currentCategories.create_partner_description && (
        <SelectField 
          name="create_partner_description"
          label="Create Partner Description" 
          value={getCategoryValue('create_partner_description', currentCategories.create_partner_description)} 
          permission="edit" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.create_partner_description)}
        />
      )}
      {currentCategories.task_performed_by && (
        <SelectField 
          name="task_performed_by"
          label="Opgave udført af:" 
          value={getCategoryValue('task_performed_by', currentCategories.task_performed_by)} 
          permission="edit" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.task_performed_by)}
        />
      )}
      {partners && partners.length > 0 && (
        <SelectField 
          name="partner"
          label="Partner" 
          value={getPartnerValue ? getPartnerValue() : ''} 
          permission="edit" 
          clName="half-col"
          options={transformPartnerOptions ? transformPartnerOptions() : []}
        />
      )}
      <TextField name="mk_standard_offer_price" label="MK Std. Tilbudspris" value={selectedRow.mk_standard_offer_price} type="number" permission="edit" clName="half-col"/>
      <TextArea name="mk_standard_offer_price_text" label="Tekst MK Std. Tilbudspris" value={stripHtmlAndFormat(selectedRow.mk_standard_offer_price_text)} permission="edit" clName="full-col" rows={4}/>
      {currentCategories.generate_pdf && (
        <SelectField 
          name="generate_pdf"
          label="Generer PDF" 
          value={getCategoryValue('generate_pdf', currentCategories.generate_pdf)} 
          permission="edit" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.generate_pdf)}
        />
      )}
      {currentCategories.generate_pdf && (
        <SelectField 
          name="confirmation_email"
          label="Bekræftelsesmail" 
          value={getCategoryValue('confirmation_email', currentCategories.confirmation_email)} 
          permission="edit" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.confirmation_email)}
        />
      )}
      <TextArea name="expected_arrival_hour" label="Forventet ankomst (Time)" value={stripHtmlAndFormat(selectedRow.expected_arrival_hour)} permission="edit" clName="full-col" rows={4}/>
      <TextArea name="expected_arrival_minute" label="Forventet ankomst (Minutter)" value={stripHtmlAndFormat(selectedRow.expected_arrival_minute)} permission="edit" clName="full-col" rows={4}/>
      {currentCategories.send_sms && (
        <SelectField 
          name="send_sms"
          label="Send SMS" 
          value={getCategoryValue('send_sms', currentCategories.send_sms)} 
          permission="edit" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.send_sms)}
        />
      )}
      <TextField 
        name="painterkanon_inquiry_offer" 
        label="MalerKanon Henvendelse / Tilbud" 
        value={
          selectedRow.painterkanon_inquiry_offer_title && selectedRow.painterkanon_inquiry_offer_title !== null && selectedRow.painterkanon_inquiry_offer_title !== 'null'
            ? selectedRow.painterkanon_inquiry_offer_title 
            : selectedRow.painterkanon_inquiry_offer && selectedRow.painterkanon_inquiry_offer !== null && selectedRow.painterkanon_inquiry_offer !== 'null'
              ? selectedRow.painterkanon_inquiry_offer
              : ''
        } 
        type="text" 
        permission="view-only" 
        clName="full-col"
      />
      {currentCategories.floor_cannon && (
        <SelectField 
          name="floor_cannon"
          label="GulvKanonen" 
          value={getCategoryValue('floor_cannon', currentCategories.floor_cannon)} 
          permission="view-only" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.floor_cannon)}
        />
      )}
      {/* Display Images from files object - Static sections for each field */}
      {(selectedRow.files !== undefined || Object.keys(filesToUpload).length > 0) && (
        <div className="form-group full-col">
          <div className="uploads-image">
            {/* Helper function to render a single field section */}
            {(() => {
              const renderFieldSection = (fieldName, customLabel, alwaysShow = false) => {
                const existingFiles = selectedRow.files?.[fieldName] || [];
                const pendingFiles = filesToUpload[fieldName] || [];
                const deletedFileIds = filesToDelete[fieldName] || [];
                
                // Filter only image files from existing files, excluding deleted ones
                const imageFiles = existingFiles.filter(file => {
                  if (!file) return false;
                  const filename = file.filename || '';
                  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg'];
                  const isImage = imageExtensions.some(ext => filename.toLowerCase().endsWith(ext));
                  const isDeleted = file.file_id && deletedFileIds.includes(file.file_id);
                  return isImage && !isDeleted;
                });
                
                // Create preview URLs for pending uploads
                const pendingImageFiles = pendingFiles.map((file, index) => ({
                  file: file,
                  previewUrl: URL.createObjectURL(file),
                  name: file.name,
                  isPending: true,
                  index: index
                }));
                
                const allImages = [...imageFiles, ...pendingImageFiles];
                
                // Only render if there are files, pending uploads, or if alwaysShow is true (for editable fields)
                if (!alwaysShow && allImages.length === 0 && !selectedRow.files?.[fieldName] && !filesToUpload[fieldName]) {
                  return null;
                }
              
                return (
                  <div key={fieldName} className="image-field-wrapper">
                    <div className="label">
                      {customLabel || fieldName.replace(/-/g, ' ').charAt(0).toUpperCase() + fieldName.replace(/-/g, ' ').slice(1).toLowerCase()}
                    </div>
                    <div className="uploads-image__wrap">
                      {allImages.map((item, index) => {
                        const isPending = item.isPending;
                        const imageUrl = isPending ? item.previewUrl : item.previewUrl;
                        const fileId = isPending ? null : item.file_id;
                        const fileName = isPending ? item.name : (item.filename || '');
                        const isLastImage = index === allImages.length - 1;
                        const removeIndex = isPending ? item.index : index;
                        
                        return (
                          <React.Fragment key={`${fieldName}-${isPending ? `pending-${removeIndex}` : (fileId || index)}`}>
                            <div className={`image-wrapper ${isPending ? 'pending-upload' : ''}`}>
                              <div className="image">
                                {isPending && <div className="pending-badge">New</div>}
                                <button
                                  className="image-remove-btn"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleRemoveImage(fieldName, fileId, removeIndex);
                                  }}
                                  type="button"
                                  title="Remove image"
                                >
                                  <img src={removeIcon} alt="Remove" />
                                </button>
                                <img
                                  src={imageUrl}
                                  alt={fileName}
                                  loading="lazy"
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                  }}
                                />
                              </div>
                            </div>
                            {isLastImage && (
                              <div className="image-add-wrapper">
                                <button
                                  className="image-add-btn"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleAddImage(fieldName);
                                  }}
                                  type="button"
                                  title="Add image"
                                >
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                  </svg>
                                </button>
                              </div>
                            )}
                          </React.Fragment>
                        );
                      })}
                      {/* Show add button if no images exist */}
                      {allImages.length === 0 && (
                        <div className="image-add-wrapper">
                          <button
                            className="image-add-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleAddImage(fieldName);
                            }}
                            type="button"
                            title="Add image"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <line x1="12" y1="5" x2="12" y2="19"></line>
                              <line x1="5" y1="12" x2="19" y2="12"></line>
                            </svg>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                );
              };
              
              return (
                <>
                  {/* Image fields in correct order based on db_fields.md */}
                  {renderFieldSection('vedhaeft-billeder', 'Vedhæft billeder', true)}
                  {renderFieldSection('vedhaeft-billeder-from-billede-modtagelse', 'Vedhæft billeder from Billede modtagelse', true)}
                  {renderFieldSection('images-from-partners', 'Billeder fra maler inden opstart', true)}
                  {renderFieldSection('billeder-mandag', 'Billeder Mandag', true)}
                  {renderFieldSection('billeder-tirsdag', 'Billeder Tirsdag', true)}
                  {renderFieldSection('billeder-onsdag', 'Billeder Onsdag', true)}
                  {renderFieldSection('billeder-torsdag', 'Billeder Torsdag', true)}
                  {renderFieldSection('billeder-fredag', 'Billeder Fredag', true)}
                  {renderFieldSection('billeder-lordag', 'Billeder Lørdag', true)}
                  {renderFieldSection('billeder-sondag', 'Billeder Søndag', true)}
                  {renderFieldSection('vedhaeft-faktura', 'Vedhæft Faktura', true)}
                </>
              );
            })()}
          </div>
        </div>
      )}
      <TextArea name="short_complaint_link" label="Short Reklamation link" value={stripHtmlAndFormat(selectedRow.short_complaint_link)} permission="edit" clName="full-col" rows={4}/>
      {/* Reklamations billeder field - displayed under Short Reklamation link */}
      <div className="form-group full-col">
        <div className="uploads-image">
          {(() => {
            const fieldName = 'reklamations-billeder';
            const customLabel = 'Reklamations billeder';
            const existingFiles = selectedRow.files?.[fieldName] || [];
            const pendingFiles = filesToUpload[fieldName] || [];
            const deletedFileIds = filesToDelete[fieldName] || [];
            
            // Filter only image files from existing files, excluding deleted ones
            const imageFiles = existingFiles.filter(file => {
              if (!file) return false;
              const filename = file.filename || '';
              const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg'];
              const isImage = imageExtensions.some(ext => filename.toLowerCase().endsWith(ext));
              const isDeleted = file.file_id && deletedFileIds.includes(file.file_id);
              return isImage && !isDeleted;
            });
            
            // Create preview URLs for pending uploads
            const pendingImageFiles = pendingFiles.map((file, index) => ({
              file: file,
              previewUrl: URL.createObjectURL(file),
              name: file.name,
              isPending: true,
              index: index
            }));
            
            const allImages = [...imageFiles, ...pendingImageFiles];
            
            return (
              <div className="image-field-wrapper">
                <div className="label">{customLabel}</div>
                <div className="uploads-image__wrap">
                  {allImages.map((item, index) => {
                    const isPending = item.isPending;
                    const imageUrl = isPending ? item.previewUrl : item.previewUrl;
                    const fileId = isPending ? null : item.file_id;
                    const fileName = isPending ? item.name : (item.filename || '');
                    const isLastImage = index === allImages.length - 1;
                    const removeIndex = isPending ? item.index : index;
                    
                    return (
                      <React.Fragment key={`${fieldName}-${isPending ? `pending-${removeIndex}` : (fileId || index)}`}>
                        <div className={`image-wrapper ${isPending ? 'pending-upload' : ''}`}>
                          <div className="image">
                            {isPending && <div className="pending-badge">New</div>}
                            <button
                              className="image-remove-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveImage(fieldName, fileId, removeIndex);
                              }}
                              type="button"
                              title="Remove image"
                            >
                              <img src={removeIcon} alt="Remove" />
                            </button>
                            <img
                              src={imageUrl}
                              alt={fileName}
                              loading="lazy"
                              onError={(e) => {
                                e.target.style.display = 'none';
                              }}
                            />
                          </div>
                        </div>
                        {isLastImage && (
                          <div className="image-add-wrapper">
                            <button
                              className="image-add-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleAddImage(fieldName);
                              }}
                              type="button"
                              title="Add image"
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="12" y1="5" x2="12" y2="19"></line>
                                <line x1="5" y1="12" x2="19" y2="12"></line>
                              </svg>
                            </button>
                          </div>
                        )}
                      </React.Fragment>
                    );
                  })}
                  {/* Show add button if no images exist */}
                  {allImages.length === 0 && (
                    <div className="image-add-wrapper">
                      <button
                        className="image-add-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleAddImage(fieldName);
                        }}
                        type="button"
                        title="Add image"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <line x1="12" y1="5" x2="12" y2="19"></line>
                          <line x1="5" y1="12" x2="19" y2="12"></line>
                        </svg>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            );
          })()}
        </div>
      </div>
      {currentCategories.send_complaint_images_to_painter && (
        <SelectField 
          name="send_complaint_images_to_painter"
          label="Send reklamations billeder til maleren" 
          value={getCategoryValue('send_complaint_images_to_painter', currentCategories.send_complaint_images_to_painter)} 
          permission="edit" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.send_complaint_images_to_painter)}
        />
      )}
      <TextArea name="order_comment" label="Kommentar til bestilling" value={stripHtmlAndFormat(selectedRow.order_comment)} permission="edit" clName="full-col" rows={4}/>
      <TextField name="material_pickup_date" label="Materiale afhentningsdato" value={formatDate(selectedRow.material_pickup_date)} type="date" permission="edit" clName="full-col"/>
      <TextArea name="delivery_address" label="Leveringsadresse til kunde" value={stripHtmlAndFormat(selectedRow.delivery_address)} permission="edit" clName="full-col" rows={4}/>
      <TextField name="order_id" label="BestillingsID" value={selectedRow.order_id} type="text" permission="view-only" clName="full-col"/>
      <TextArea name="painter_name_picking_up" label="Navn på maler der afhenter:" value={stripHtmlAndFormat(selectedRow.painter_name_picking_up)} permission="edit" clName="full-col" rows={4}/>
      {currentCategories.material_order && (
        <SelectField 
          name="material_order"
          label="Materiale Bestilling" 
          value={getCategoryValue('material_order', currentCategories.material_order)} 
          permission="edit" 
          clName="full-col"
          options={transformCategoryOptions(currentCategories.material_order)}
        />
      )}
      <TextField name="misc_expenses" label="Diverse udgifter: (Bil, marketing, mv.)" value={selectedRow.misc_expenses} type="number" permission="edit" clName="half-col"/>
      <TextField name="employee_salary_cost_percent" label="Medarbejder løn udgift i %" value={selectedRow.employee_salary_cost_percent} type="text" permission="view-only" clName="half-col"/>
      <TextField name="start-date" label="Start date" value={formatDate(selectedRow.date_start)} type="date" permission="edit" clName="half-col"/>
      <TextField name="End-date" label="End date" value={formatDate(selectedRow.date_end)} type="date" permission="edit" clName="half-col"/>
    </>
  );
};

export default TaskFields;

